<style scoped lang="less">
@import "../../less/colors";

.slider_wrapper {
    position: relative;
    z-index: 0;

    .dots {
        position: absolute;
        z-index: 999;
        bottom: 1em;
        left: 0;
        right: 0;
        text-align: center;

        .dot {
            display: inline-block;
            background: @red;
            border-radius: 1em;
            width: 1em;
            height: 1em;
            margin: 0 0.1em;

            &.active {
                background: @white;
            }

            a {
                display: block;
                width: 1em;
                height: 1em;
            }
        }
    }
}

</style>

<template>
    <div class="slider_wrapper" :style="{'height': height + (height.indexOf('%') > -1 ? '' : 'px')}" v-if="files" ref="slider_wrapper">
        <slider-base :images="files" :bus="bus" :type="type" :transition="parseInt(transition, 10)" @indexChanged="currentIndex = $event"></slider-base>
        <div class="dots">
            <div class="dot" v-for="(file, index) in files" :key="file.id" :class="{active: index === currentIndex}"><a @click="show(index)"></a></div>
        </div>
    </div>
</template>

<script>
    import Collection from './collection.js';
    export default {
        extends: Collection,

        data() {
            return {
                currentIndex: 0,
                bus: new Vue,
                intervalToken: undefined,
            };
        },

        props: {
            height: {
                type: String,
                default: '150',
            },
            interval: String,
            transition: {
                type: String,
                default: '500'
            },
            type: {
                type: String,
                default: 'contain',
                validator: function (value) {
                    return ['cover', 'contain'].indexOf(value) !== -1
                }
            },
        },

        mounted() {
            this.bus.$emit('setClient', this.$refs['slider_wrapper']);
        },

        destroyed() {
        },

        methods: {

            show(index) {
                this.bus.$emit('show', index);
                if (this.intervalToken) {
                    clearInterval(this.intervalToken);
                }
            },

            filesLoaded() {
                setTimeout(() => {
                    this.bus.$emit('show', this.currentIndex);

                    const interval = parseInt(this.interval, 10);
                    if (interval) {
                        this.intervalToken = setInterval(() => {
                            this.bus.$emit('show', this.currentIndex + 1);
                        }, interval);
                    }
                });
            }

        },
    }
</script>
